import { render, staticRenderFns } from "./SpamDomain.vue?vue&type=template&id=97fe0842&scoped=true"
import script from "./SpamDomain.vue?vue&type=script&lang=js"
export * from "./SpamDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97fe0842",
  null
  
)

export default component.exports